/**
 * Fase 1 do fluxo de auditoria (spec 2026-09-11, §5.2) — o toggle "Mostrar sem escala
 * prevista" é preferência de trabalho do auditor, não filtro de negócio: fica por usuário no
 * `localStorage` e nasce desligado.
 *
 * Todo acesso é embrulhado em try/catch: navegador com armazenamento bloqueado (modo privado,
 * política corporativa) faz `localStorage` LANÇAR, e a fila não pode deixar de carregar por
 * causa de um toggle.
 */

const USER_ID_KEY = '@ME:userId'
const PREFIX = '@ME:dsAttendance:showNoScheduleExpected'

/** Chave por usuário — a máquina costuma ser compartilhada entre auditores. */
export function noScheduleExpectedStorageKey(userId: string | number | null | undefined): string {
  const id = userId === null || userId === undefined || userId === '' ? 'anon' : String(userId)
  return `${PREFIX}:${id}`
}

function currentUserId(): string | null {
  try {
    return localStorage.getItem(USER_ID_KEY)
  } catch {
    return null
  }
}

/** Lê a preferência; qualquer falha (ou ausência) devolve `false` — o padrão do spec. */
export function readShowNoScheduleExpected(): boolean {
  try {
    return localStorage.getItem(noScheduleExpectedStorageKey(currentUserId())) === 'true'
  } catch {
    return false
  }
}

/** Grava a preferência; falha de armazenamento é silenciosa e não interrompe a busca. */
export function writeShowNoScheduleExpected(value: boolean): void {
  try {
    localStorage.setItem(noScheduleExpectedStorageKey(currentUserId()), String(value))
  } catch {
    // Sem persistência o toggle ainda funciona na sessão — não há o que avisar ao usuário.
  }
}
